module.exports = __webpack_public_path__ + "img/title-id12.f497a9aa.png";